import { render, staticRenderFns } from "./activity-form-section-preview.vue?vue&type=template&id=2442d8c2&"
import script from "./activity-form-section-preview.vue?vue&type=script&lang=js&"
export * from "./activity-form-section-preview.vue?vue&type=script&lang=js&"
import style0 from "./activity-form-section-preview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "activity-form-section-preview.vue"
export default component.exports